import React, { Component } from "react";
import Header from "../../Components/MainLayout/Header";
import Axios from "axios";
import { connect } from "react-redux";
import Skeleton from "react-loading-skeleton";
import { withRouter } from "react-router-dom";

import Loader from "../../Components/MainLayout/Loader";
import MySnackbar from "../../Components/MyComponents/MySnackbar";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class ExamQuestions extends Component {
  state = {
    exam: [],
    loading: false,
    fakeData: [1, 2, 3, 4],
    snackbar: false,
    isLoader: false,
  };

  componentDidMount() {
    this.fetchQuestions({
      student_class: this.props.user.student_class.id,
      section: this.props.user.student_section.id,
      session: this.props.user.student_info.session.id,
      status: true,
    });
  }

  fetchQuestions = (params = {}) => {
    this.setState({ loading: true });
    Axios.get(`/api/unit-test-question`, {
      params: { ...params },
      type: "json",
    }).then((res) => {
      this.setState({ questionData: res.data, loading: false });
    });
  };

  submitAnswer = (id) => {
    let form_data = new FormData();
    if (this.state.answerFile) {
      this.setState({ isLoader: true });
      form_data.append(
        "file",
        this.state.answerFile,
        this.state.answerFile.name
      );
      form_data.append("student_info", this.props.user.student_info.id);
      form_data.append("unit_test_question", id);

      Axios.post(`/api/unit-test-answer`, form_data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          if (response.status === 201) {
            //   message.success("Question Added Successfully ");
            this.setState({
              isLoader: false,
              visible: false,
              snackMsg: "Answer Submitted Successfully",
              snackbar: true,
              answerFile: null,
            });
            this.handleSnackbar();
            this.fetchQuestions({
              student_class: this.props.user.student_class.id,
              session: this.props.user.student_info.session.id,
              status: true,
            });
          }
        })
        .catch((error) => {
          this.setState({
            snackMsg: "Answer Not Submitted",
            snackbar: true,
            isLoader: false,
          });
          this.handleSnackbar();
          console.log(error);
          // message.error("Something went wrong");
        });
    } else {
      this.setState({
        snackMsg: "Please Upload your answer file",
        snackbar: true,
      });
      this.handleSnackbar();
    }
  };

  handleFileChange = (e) => {
    this.setState({
      answerFile: e.target.files[0],
    });
  };

  handleSnackbar = () => {
    setTimeout(() => this.setState({ snackbar: false, snackMsg: "" }), 2000);
  };
  render() {
    let { questionData, snackMsg, snackbar } = this.state;
    console.log(this, "student_classstudent_class");
    return (
      <div>
        <Header to="/home" title="Online Exam" />
        {this.state.loading ? (
          <div className="container pt-3">
            {this.state.fakeData?.map((item, index) => {
              return (
                <div
                  key={index}
                  className="border p-3 shadow-sm rounded-lg mb-3"
                >
                  <Skeleton width={100} />
                  <Skeleton count={2} />
                </div>
              );
            })}
          </div>
        ) : (
          <div className="container pt-3 pb-5">
            {this.state.questionData?.length === 0 ? (
              <p className="th-12 text-center py-5">No Question Assigned.</p>
            ) : (
              this.state.questionData?.map((item, index) => {
                return (
                  <div key={index}>
                    <div className="border shadow-sm rounded mb-2 p-3">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="">{item.exam_name}</div>
                        <div className="pl-2">
                          <div className="th-12 th-medium th-cap text-right">
                            {item?.file ? (
                              <a
                                className="btn th-btn-primary-outline mt-2 px-4 py-1"
                                href={item?.file}
                                download
                              >
                                Download Question
                              </a>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                      <label for="image" className="pt-3">
                        Submit Your Answer
                      </label>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="">
                          <input
                            className="form-control-file"
                            type="file"
                            id="image"
                            accept="image/png, image/jpeg,.xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"
                            onChange={this.handleFileChange}
                          />
                        </div>
                        <div className="pl-2">
                          <div className="th-12 th-medium th-cap text-right">
                            <div
                              className="btn th-btn-primary-outline mt-2 px-4 py-1"
                              onClick={() => this.submitAnswer(item.id)}
                            >
                              Submit
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
            <div className="py-3"></div>
          </div>
        )}
        {this.state.snackbar ? <MySnackbar title={snackMsg} /> : null}
        {this.state.isLoader ? (
          <div className="th-loader my-2 pr-2 text-center">
            <Loader />
          </div>
        ) : null}
      </div>
    );
  }
}
export default withRouter(connect(mapStateToProps)(ExamQuestions));
